var render = function (_h,_vm) {var _c=_vm._c;return _c('IconFA',{staticClass:"text-4xl animation-spin mt-20",class:[_vm.data.class, _vm.data.staticClass],attrs:{"icon":['fas', 'spinner-third']}})}
var staticRenderFns = []

export { render, staticRenderFns }